@if (state(); as st) {
  @if (st.isCta && st.ctaLabelKey) {
    <button
      class="review-badge--verify-now"
      (click)="onRequestReview($event)"
      type="button"
      [attr.aria-label]="st.ctaLabelKey | transloco"
    >
      <mat-icon class="warning-icon" aria-hidden="true">report_problem</mat-icon>
      <span>{{ st.ctaLabelKey | transloco }}</span>
      <mat-icon class="arrow-icon" aria-hidden="true">arrow_forward</mat-icon>
    </button>
  } @else {
    <app-status-indicator
      [status]="st.variant"
      [label]="st.labelKey | transloco"
      [meaning]="st.meaning"
      [matTooltip]="st.tooltipText || ''"
      matTooltipPosition="above"
      matTooltipClass="signoff-tooltip"
    />
  }
}
